module.exports = __webpack_public_path__ + "static/media/add_book_to_cart.ea1c7e0a.png";